import i18next from 'i18next';
import moment from 'moment';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import countries from 'i18n-iso-countries';

import isElectron from 'is-electron';
import appConfig from 'app-config';
import { LocalesData } from './utils/locales-data';

// Import and register locales for the countries object.
// This is not related to our translation files.
Promise.all(
    Object.values(LocalesData)
        .map((locale) => locale.i18nIsoCode)
        .filter(Boolean)
        .map(
            (localeIsoCode) =>
                import(`i18n-iso-countries/langs/${localeIsoCode}.json`),
        ),
).then((modules) => modules.forEach(countries.registerLocale));

const loadPath =
    isElectron() && appConfig.production
        ? './dist/locales/{{lng}}.json'
        : `/locales/{{lng}}.json?v=${appConfig.version}`;
const arrayOfLanguageCodes = Object.values(LocalesData)
    .map((locale) => locale.fileCode)
    .filter(Boolean);

const options = {
    debug: false,
    fallbackLng: 'en',
    load: 'currentOnly',
    preload: arrayOfLanguageCodes,
    nsSeparator: false,
    keySeparator: false,
    useCookie: false,
    useLocalStorage: false,
    cache: {
        enabled: false,
    },
    backend: {
        loadPath: loadPath,
    },
    detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'applicationLanguage',
        caches: false,
        convertDetectedLanguage: (lng) => {
            const locale = LocalesData[lng];
            if (locale?.fileCode) return locale.fileCode;

            const languageCode = lng.split('-')[0];
            const fallbackLocale = Object.entries(LocalesData).find(
                ([key]) =>
                    key === languageCode || key.startsWith(`${languageCode}-`),
            );
            return fallbackLocale?.[1].fileCode ?? lng;
        },
    },
};

// catch the event and make changes accordingly
i18next.on('languageChanged', (language) => {
    // E.g. set the moment locale with the current language
    moment.locale(language);
});

i18next.use(HttpApi).use(LanguageDetector).init(options);

export { i18next };
